/**
 * The MIT License (MIT)
 *
 * Copyright (c) 2016 Michał Osadnik osdnk
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import React, { useEffect } from 'react';
import { disableAnimatedChartRendering } from 'features/invest/debug';
import SvgComponent from './SvgComponent';
import InternalContext from './utils/internalContext';
const ChartPath = (props) => {
    const { animatedPathProps, animatedPathStyle, animatedCurrentPriceCircleProps, gestureEnabled, height, longPressGesture, width, children, pathProps, layoutSize, animatedStrokeProps, animatedShadowProps, } = props;
    useEffect(() => {
        layoutSize.value = { height, width };
    }, [height, layoutSize, width]);
    const Context = InternalContext;
    return (<Context.Provider 
    // eslint-disable-next-line react/jsx-no-constructed-context-values
    value={{
            animatedPathProps,
            animatedPathStyle,
            animatedCurrentPriceCircleProps,
            gestureEnabled,
            height,
            longPressGesture,
            width,
            pathProps,
            animatedStrokeProps,
        }}>
      {disableAnimatedChartRendering ? children : <SvgComponent animatedShadowProps={animatedShadowProps}/>}
    </Context.Provider>);
};
export default ChartPath;
